/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/text1/answer/answer_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ TEXT 1 ANSWER ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// used to create markup structure and render UI

class Text1Answer extends Component {
    constructor(props) {
        super(props);
        // state to store FontSize of the answer.
        this.state = { fontSize: 'standard' };
        this.answerEl = null;
        this.availableSizes = ['standard', 'medium', 'large'];
    }

    componentDidMount() {
        this.adjustFontSize();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.text !==  this.props.text)
            this.adjustFontSize();
    }

    adjustFontSize() {
        let quesSize = 'standard';
        this.setState({
            quesSize: quesSize
        }, () => this.readjustFontSize())
    }

    // the current height and width of the question elements are grabbed and checked here and font size is adjusted accordingly.
    // Now we have the exact height of question element and so we can adjust the font size accordingly.
    // in very rare cases, this function will be called more than 2 times. So no loop here.
    readjustFontSize() {
        let ansSize = this.state.fontSize;
        const currAnsSizeIndex = this.availableSizes.indexOf(ansSize);
        if (this.answerEl && (this.getContainerDimensions().height - this.getElementInContainerDimensions().height) < 0 && ansSize !== 'large' ) {
            ansSize = this.availableSizes[currAnsSizeIndex + 1] ? this.availableSizes[currAnsSizeIndex + 1] : ansSize;
            this.setState({
                fontSize: ansSize
            }); // again calling it just in case to see if fonts need more readjustment. Wont be called unless font needs resizing.
        }
    }

    getContainerDimensions() {
        const el = this.answerEl;
        let height = el.clientHeight;
        return { width: el.clientWidth, height: height };
    }

    getElementInContainerDimensions() {
        const el = this.answerEl.childNodes[2];
        return { width: el.clientWidth, height: el.clientHeight };
    }

    render() {
        return(
            <span className={`${sheet.classes.uniqueanswer} uniqueanswer`}>
                <span ref={span => this.answerEl = span} className={`${sheet.classes.desc} desc`}>
                    <span class={`background`}></span>
                    <span class={`icon`}></span>
                    <span className={`text ${this.state.fontSize}`}>{this.props.text}</span>
                </span>
            </span>
        )
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Text1Answer;
